import { combineReducers } from 'redux';
import { cart } from './cart_reducer';

const rootReducer = combineReducers({
  cart
});

export default rootReducer;